import styled from "styled-components";

const StyledDiv = styled.div`
  margin-bottom: 1rem;
`

const StyledLabel = styled.label`
  line-height: 20px;
  font-size: 1rem;
  font-weight: bold;
  display: inline-block;
  white-space: nowrap;
  margin-bottom: 0.5rem;
  margin-right: 0.5rem;
`;

export const Field = ({htmlFor, label, children}) => {
  return (
    <StyledDiv>
      <StyledLabel htmlFor={htmlFor}>{label}</StyledLabel>
      {children}
    </StyledDiv>
  )
}